import RetailerUserModelMC from '../presentation/models/RetailerUserModelMC';

/**
 * Fetches active agents by role and dispatches the data to the store.
 *
 * @returns {Function} A thunk action creator that dispatches the agent data.
 */
export const fetchActiveAgents = () => (dispatch) => {
  dispatch({ type: 'AGENTS_LOADING' });

  RetailerUserModelMC.getActiveRetailerUsers()
    .then((data) => dispatch({ type: 'SET_AGENTS_DATA', data }))
    .catch((err) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', err });
      alert(err.message || 'An unexpected error occurred.');
    });
};

/**
 * Fetches active agents by role and persists the data if the agent list is empty.
 * Prevents duplicate requests by checking both agentList length and loading state.
 *
 * @returns {Function} A thunk action creator that fetches and dispatches the agent data.
 */
export const fetchActiveAgentsByRoleIfEmpty = () => (dispatch, getState) => {
  const { agentList, loading } = getState().agentsReducer;

  // Only fetch if agentList is empty and not currently loading
  if (!agentList.length && !loading) {
    dispatch({ type: 'AGENTS_LOADING' });

    RetailerUserModelMC.getActiveRetailerUsersByRole()
      .then((data) => dispatch({ type: 'SET_AGENT_LIST_DATA', data }))
      .catch((err) => {
        dispatch({ type: 'LOAD_DATA_FAILURE', err });
        alert(err.message || 'An unexpected error occurred.');
      });
  }
};

/**
 * Fetches agent data from the specified API endpoint.
 *
 * @param {string} endpoint - The API endpoint to fetch data from.
 * @returns {Promise<Object>} A promise that resolves to the data in JSON format.
 * @throws {Error} Throws an error if the response is not ok.
 */
const fetchAgentsApi = (endpoint) => fetch(endpoint, {
  method: 'GET',
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  }
}).then((res) => {
  if (!res.ok) {
    throw new Error(`Error: ${res.status}`);
  }
  return res.json();
});

/**
 * Fetches active agent data from the specified API endpoint and dispatches it to the store.
 *
 * @returns {Function} A thunk action creator that dispatches the data to the store.
 */
export const fetchAgents = () => {
  const endpoint = `/api/v1/retailer_users/actives`;

  return (dispatch) => {
    fetchAgentsApi(endpoint)
      .then((data) => dispatch({ type: 'SET_AGENTS_DATA', data }))
      .catch((err) => {
        dispatch({ type: 'LOAD_DATA_FAILURE', err });
        alert(err.message || 'An unexpected error occurred.');
      });
  };
};


/**
 * Fetches active agents by role and dispatches the data to the store.
 * This is a legacy function it shall be replaced later on by one of the above to prevent duplicate requests.
 *
 * @returns {Function} A thunk action creator that dispatches the agent data.
 */
export const fetchActiveAgentsByRole = () => (dispatch) => {
  const endpoint = `/api/v1/retailer_users/by_role`;

  fetchAgentsApi(endpoint)
    .then((data) => dispatch({ type: 'SET_AGENTS_DATA', data }))
    .catch((err) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', err });
      alert(err.message || 'An unexpected error occurred.');
    });
};
